import * as THREE from "three";

export class Stage {
  constructor(canvas) {
    this.canvas = canvas;
    this.cameraV = 0.0000003;

    this.rendererParam = {
      clearColor: 0x000000,
      width: this.getCVsize().width,
      height: this.getCVsize().height,
    };

    this.cameraParam = {
      fov: 40,
      near: 0.1,
      far: 100.0,
      lookAt: new THREE.Vector3(0, 0, 0),
      x: 0,
      y: 0,
      z: 3,
    };

    this.scene = null;
    this.camera = null;
    this.renderer = null;
    this.geometry = null;
    this.material = null;
    this.mesh = null;
    this.isInitialized = false;
  }

  init() {
    this.setScene();
    this.setRenderer();
    this.setCamera();

    this.isInitialized = true;
  }

  getCVsize() {
    const w = this.canvas.parentNode.offsetWidth;
    const h = this.canvas.parentNode.offsetHeight;
    return { width: w, height: h };
  }

  setScene() {
    this.scene = new THREE.Scene();
  }

  setRenderer() {
    const canvas = this.canvas;
    this.renderer = new THREE.WebGLRenderer({ canvas: canvas, alpha: true });
    this.renderer.setPixelRatio(Math.min(2, window.devicePixelRatio));
    this.renderer.setClearColor(0x000000, 0.0);
    this.renderer.setSize(this.rendererParam.width, this.rendererParam.height);
  }

  setLight() {}

  setCamera() {
    if (!this.isInitialized) {
      this.camera = new THREE.PerspectiveCamera(
        this.cameraParam.fov, // fov
        0, // aspect
        this.cameraParam.near,
        this.cameraParam.far
      );
      this.camera.position.set(
        this.cameraParam.x,
        this.cameraParam.y,
        this.cameraParam.z
      );
      this.camera.lookAt(this.cameraParam.lookAt);
    }
    this.camera.aspect = this.getCVsize().width / this.getCVsize().height;
    this.camera.updateProjectionMatrix();
    this.renderer.setSize(this.getCVsize().width, this.getCVsize().height);
  }

  render() {
    this.renderer.render(this.scene, this.camera);
  }

  onResize() {
    this.setCamera();
  }

  onRaf() {
    this.render();
  }
}
